import {
  PREDICAMENT_STATE_NO,
  PREDICAMENT_STATE_YES,
  YES_NO_FIELD_OPTIONS,
} from "core/consts";
import { RadioWrapper } from "ds_legacy/components/RadioGroup";
import { ERROR_COLOR } from "ds_legacy/materials/colors";
import { HorizontalLayout } from "ds_legacy/materials/layouts";
import { border, dp, margin } from "ds_legacy/materials/metrics";
import { Subheading } from "ds_legacy/materials/typography";
import { FormElement, FormElementProps } from "react-forms-state";
import styled from "styled-components";
import { useTranslations } from "translations";

const RadioBox = styled.div`
  display: flex;
  align-items: stretch;
  flex: 0 0 auto;
  flex-direction: column;
`;

const RadioGroupBox = styled.div<{ flex?: any; inline?: any }>`
  display: flex;
  flex: ${({ flex }) => flex};
  align-items: ${(props) => (props.inline ? "center" : "stretch")};
  flex-direction: ${(props) => (props.inline ? "row" : "column")};
`;

const OptionsBox = styled.div<{ error?: any; inline?: any }>`
  display: flex;
  flex: 1;
  margin-left: ${(props) => (props.inline ? dp(8) : undefined)};
  flex-direction: ${(props) => (props.inline ? "row" : "column")};
  align-items: stretch;
  border-bottom: ${(props) =>
    border({ color: ERROR_COLOR, width: props.error ? 2 : 0 })};
`;

export type YesNoRadioInputFieldType = {
  elementName: string;
  isImportant?: boolean;
  label: string;
  onChange: (a: any) => void;
  useEmptyAsBool?: boolean;
  value: number | string | null;
};

export default FormElement()(function YesNoRadioInputField({
  elementName,
  isImportant,
  label,
  onChange,
  useEmptyAsBool,
  value,
}: FormElementProps & YesNoRadioInputFieldType) {
  const translations = useTranslations();

  const options = [
    {
      id: PREDICAMENT_STATE_NO,
      label: translations.actions.no,
      value: YES_NO_FIELD_OPTIONS.NO,
    },
    {
      id: PREDICAMENT_STATE_YES,
      label: translations.actions.yes,
      value: useEmptyAsBool ? "" : YES_NO_FIELD_OPTIONS.YES,
    },
  ];

  return (
    <RadioGroupBox flex inline>
      {label && (
        <Subheading bold={isImportant} margin={margin(1, 0)}>
          {label}
        </Subheading>
      )}
      <HorizontalLayout>
        <OptionsBox inline>
          {options.map((option) => (
            <RadioBox key={`radiobutton-${option.value}`}>
              <RadioWrapper
                elementName={elementName}
                id={`radiobutton_${elementName}_${option.id}`}
                label={option.label}
                radioValue={option.value}
                value={useEmptyAsBool && typeof value === "string" ? "" : value}
                onChange={onChange}
              />
            </RadioBox>
          ))}
        </OptionsBox>
      </HorizontalLayout>
    </RadioGroupBox>
  );
});
